module.exports = __webpack_public_path__ + "img/caret-down-fill.66f40ae1.svg";